import styled, { css } from "styled-components";

import type { RootProps } from "./CSSGridTemplate.types";

const template = ({ templates }: RootProps) => css`
  ${({ theme }) => {
    const styles = Object.keys(templates).reduce(
      (acc, breakpoint: keyof RootProps["templates"]) => {
        if (!templates[breakpoint]) return acc;

        let style = `grid-template: ${templates[breakpoint]?.join(`\n`)};`;

        if (breakpoint !== "all") {
          style = `${theme.breakpointsV2[breakpoint]} {${style}}`;
        }

        return acc + style;
      },
      "",
    );
    return styles;
  }}
`;

export const Root = styled.div<RootProps>`
  box-sizing: border-box;
  display: grid;
  ${props => template(props)}
`;
